// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  background-color: transparent !important;
  --background: transparent !important;
}

ion-toolbar {
  height: 80px !important;
  --background: transparent !important;
}
ion-toolbar.dark-toolbar {
  height: 65px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

span {
  color: white !important;
}

ion-toolbar ion-button {
  color: white !important;
}
ion-toolbar ion-button.dark-toolbar {
  color: black !important;
}

ion-title {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: relative;
}
ion-title .app-image {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  object-fit: cover;
  cursor: pointer;
  background: white;
}
ion-title .app-name {
  font-weight: bold;
  margin-left: 6px;
  font-size: x-large;
  position: absolute;
  margin-top: 7px;
}
ion-title .app-name.dark-toolbar {
  color: black !important;
}

.profile-avatar {
  width: 36px;
  height: 36px;
  cursor: pointer;
  margin-bottom: 5px;
  margin-right: 10px;
}
.profile-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  border: 1.5px solid black;
}

::ng-deep ion-popover.custom-setup-pin-modal {
  width: 410px !important;
  height: auto !important;
  max-height: calc(100vh - 32px) !important;
  --backdrop-opacity: 0.5;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::ng-deep ion-popover.custom-setup-pin-modal::part(content) {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 20px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  width: 410px;
  height: auto;
  max-height: calc(100vh - 32px);
}
::ng-deep ion-popover.custom-setup-pin-modal::part(backdrop) {
  background: rgba(0, 0, 0, 0.4) !important;
  opacity: 1 !important;
  width: 400vh;
  height: 150vh;
  transform: translate(-50%, -50%);
}

::ng-deep .ios ion-popover.custom-setup-pin-modal {
  width: 410px !important;
  max-height: 280px !important;
  --backdrop-opacity: 0.5;
  position: fixed;
  top: 50%;
  left: 47.5%;
  transform: translate(0);
}
::ng-deep .ios ion-popover.custom-setup-pin-modal::part(content) {
  border-radius: 20px;
  position: absolute;
}
::ng-deep .ios ion-popover.custom-setup-pin-modal::part(backdrop) {
  background: rgba(0, 0, 0, 0.3) !important;
  opacity: 1 !important;
  width: 400vh;
  height: 150vh;
  transform: translate(-50%, -50%);
}

::ng-deep ion-popover.custom-setup-pin-modal app-pin {
  display: block;
  width: 100%;
  height: auto;
  min-height: 240px;
  border-radius: 20px;
  overflow: hidden;
}

@media (max-width: 768px) {
  ::ng-deep ion-popover.custom-setup-pin-modal {
    --width: 95%;
    --max-width: 400px;
    margin-inline-start: 10px;
  }
  ::ng-deep ion-popover.custom-setup-pin-modal::part(backdrop) {
    width: 200vh;
    height: 200vh;
    transform: translate(-50%, -50%);
  }
  ::ng-deep ion-popover.custom-setup-pin-modal::part(content) {
    width: 95%;
    max-width: 400px;
  }
}
.sign-log-btn {
  border: 1px solid #ddd;
  border-radius: 5px;
}

ion-toolbar:not(.dark-toolbar) ion-button.active {
  position: relative;
  color: white !important;
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.7);
  opacity: 1;
}
ion-toolbar:not(.dark-toolbar) ion-button.active::after {
  content: "";
  position: absolute;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  height: 2px;
  background: white;
  border-radius: 2px;
}

ion-toolbar.dark-toolbar ion-button.active {
  position: relative;
  color: var(--ion-color-primary) !important;
  text-shadow: 0 0 8px rgba(var(--ion-color-primary-rgb), 0.3);
  filter: drop-shadow(0 0 4px rgba(255, 255, 255, 0.7));
  opacity: 1;
}
ion-toolbar.dark-toolbar ion-button.active::after {
  content: "";
  position: absolute;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  height: 2px;
  background: var(--ion-color-primary);
  border-radius: 2px;
  box-shadow: 0 0 8px rgba(var(--ion-color-primary-rgb), 0.5);
}

/* Responsive Styles */
@media (max-width: 768px) {
  .desktop-only {
    display: none !important;
  }
  .mobile-only {
    display: block !important;
    margin-left: 10px;
    font-size: 45px;
  }
  .mobile-only img {
    font-size: 40px;
  }
  ion-menu-button {
    display: block !important;
  }
  ion-title {
    text-align: right !important;
  }
  ion-title img {
    width: 35px !important;
    height: 35px !important;
    margin-right: 0px;
    margin-top: 5px;
  }
  ion-content {
    height: 80px;
  }
  ion-content.dark-toolbar {
    background-color: transparent !important;
    color: white;
  }
  .ios ion-content.dark-toolbar {
    height: 80px !important;
  }
  ion-content.dark-toolbar:not(.ios) {
    height: 65px !important;
  }
  ion-toolbar {
    min-height: 0px !important;
    padding-top: 25px !important;
  }
  .wallet-btn {
    display: none !important;
  }
}
@media (min-width: 769px) {
  .mobile-only {
    display: none !important;
  }
  .desktop-only {
    display: inline !important;
  }
  .desktop-only ion-icon {
    font-size: x-large;
  }
  ion-menu-button {
    display: none !important;
  }
  ion-toolbar {
    --min-height: 65px !important;
  }
  ion-toolbar.dark-toolbar {
    --min-height: 65px !important;
  }
  .ios ion-toolbar.dark-toolbar {
    --min-height: 80px !important;
  }
  ion-title {
    text-align: left !important;
  }
  ion-title img {
    margin-right: 10px;
  }
  ion-title img.dark-toolbar {
    margin-right: 0px !important;
  }
  ion-content {
    height: 100px;
  }
  .ios ion-content.dark-toolbar {
    height: 80px !important;
  }
  ion-content.dark-toolbar:not(.ios) {
    height: 65px !important;
  }
  .wallet-btn {
    display: inline !important;
    color: white !important;
    margin-right: 10px !important;
    margin-bottom: 4px !important;
    cursor: pointer;
  }
  .wallet-btn.dark-toolbar {
    color: black !important;
  }
  .wallet-btn.active-wallet {
    color: var(--ion-color-primary) !important;
    filter: drop-shadow(0 0 4px rgba(255, 255, 255, 0.7));
  }
}
ion-popover {
  --width: 200px;
}
ion-popover ion-list {
  padding: 0;
}
ion-popover ion-item {
  --padding-start: 10px;
  --padding-end: 10px;
  --min-height: 48px;
}
ion-popover ion-item ion-icon {
  margin-right: 12px;
  color: var(--ion-color-primary);
}

.title-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 100%;
}

.ios ion-toolbar {
  --min-height: 30px !important;
  height: 82px !important;
}
.ios ion-toolbar.dark-toolbar {
  --min-height: 30px !important;
  height: 80px !important;
}
.ios ion-toolbar ion-title {
  padding-inline: 10px;
}
.ios ion-toolbar ion-title .app-image {
  width: 30px !important;
  height: 30px !important;
}
.ios ion-toolbar ion-title .app-name {
  font-size: medium !important;
  margin-top: 0 !important;
}
.ios ion-toolbar ion-button {
  font-size: 0.8rem !important;
  margin-inline: 2px !important;
}
.ios ion-toolbar .wallet-btn {
  width: 20px !important;
  margin-left: 5px !important;
  margin-right: 10px !important;
}
.ios ion-toolbar .profile-avatar {
  width: 24px !important;
  height: 24px !important;
}

@media (max-width: 768px) {
  .ios ion-content {
    height: 30px !important;
  }
  .ios ion-content.dark-toolbar {
    height: 80px !important;
  }
  .ios ion-toolbar {
    padding: 38px 5px 10px 5px !important;
  }
  .ios .mobile-only ion-menu-button {
    font-size: 24px !important;
    margin-left: 5px !important;
  }
  .ios .mobile-only {
    display: block !important;
    margin-left: 0px;
    font-size: 35px;
  }
  .ios .mobile-only img {
    font-size: 40px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/charter/charter-ui/charter-nav/charter-nav.component.scss"],"names":[],"mappings":"AAAA;EACI,wCAAA;EACA,oCAAA;AACJ;;AAEA;EACE,uBAAA;EACA,oCAAA;AACF;AACE;EACE,uBAAA;EACA,wCAAA;AACJ;;AAGA;EACI,uBAAA;AAAJ;;AAGA;EACE,uBAAA;AAAF;AAEE;EACE,uBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AADF;AAGE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EAEA,eAAA;EACA,iBAAA;AAFJ;AAUE;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AARJ;AAUI;EACE,uBAAA;AARN;;AAaA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAVF;AAYE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AAVJ;;AAcA;EACE,uBAAA;EACA,uBAAA;EACA,yCAAA;EACA,uBAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAXF;AAcE;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,mBAAA;EACA,yCAAA;EACA,YAAA;EACA,YAAA;EACA,8BAAA;AAZJ;AAeE;EACE,yCAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;EACA,gCAAA;AAbJ;;AAiBA;EACE,uBAAA;EACA,4BAAA;EACA,uBAAA;EACA,eAAA;EACA,QAAA;EACA,WAAA;EACA,uBAAA;AAdF;AAgBE;EACE,mBAAA;EACA,kBAAA;AAdJ;AAiBE;EACE,yCAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;EACA,gCAAA;AAfJ;;AAmBA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAhBF;;AAmBA;EACE;IACE,YAAA;IACA,kBAAA;IACA,yBAAA;EAhBF;EAkBE;IACE,YAAA;IACA,aAAA;IACA,gCAAA;EAhBJ;EAoBA;IACE,UAAA;IACA,gBAAA;EAlBF;AACF;AAqBA;EACI,sBAAA;EACA,kBAAA;AAnBJ;;AAsBA;EACI,kBAAA;EACA,uBAAA;EACA,6CAAA;EACA,UAAA;AAnBJ;AAqBI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AAnBR;;AAuBA;EACI,kBAAA;EACA,0CAAA;EACA,4DAAA;EACA,qDAAA;EACA,UAAA;AApBJ;AAsBK;EACG,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,2DAAA;AApBR;;AAwBA,sBAAA;AACA;EACE;IACE,wBAAA;EArBF;EAwBA;IACE,yBAAA;IACA,iBAAA;IACA,eAAA;EAtBF;EAwBE;IACI,eAAA;EAtBN;EA0BC;IACC,yBAAA;EAxBF;EA2BA;IACE,4BAAA;EAzBF;EA2BE;IACE,sBAAA;IACA,uBAAA;IACA,iBAAA;IACA,eAAA;EAzBJ;EA6BA;IACE,YAAA;EA3BF;EA6BE;IACE,wCAAA;IACA,YAAA;EA3BJ;EA+BA;IACE,uBAAA;EA7BF;EAgCA;IACE,uBAAA;EA9BF;EAiCA;IACE,0BAAA;IACA,4BAAA;EA/BF;EAkCA;IACE,wBAAA;EAhCF;AACF;AAmCA;EACE;IACE,wBAAA;EAjCF;EAmCA;IACE,0BAAA;EAjCF;EAmCE;IACE,kBAAA;EAjCJ;EAoCA;IACE,wBAAA;EAlCF;EAqCA;IACE,6BAAA;EAnCF;EAqCE;IACE,6BAAA;EAnCJ;EAuCA;IACE,6BAAA;EArCF;EAwCA;IACE,2BAAA;EAtCF;EAwCE;IACE,kBAAA;EAtCJ;EAwCI;IACE,4BAAA;EAtCN;EA2CA;IACE,aAAA;EAzCF;EA4CA;IACE,uBAAA;EA1CF;EA6CA;IACE,uBAAA;EA3CF;EA8CA;IACE,0BAAA;IACA,uBAAA;IACA,6BAAA;IACA,6BAAA;IACA,eAAA;EA5CF;EA8CE;IACE,uBAAA;EA5CJ;EA8CE;IACE,0CAAA;IACA,qDAAA;EA5CJ;AACF;AAgDA;EACE,cAAA;AA9CF;AAgDE;EACE,UAAA;AA9CJ;AAiDE;EACE,qBAAA;EACA,mBAAA;EACA,kBAAA;AA/CJ;AAiDI;EACE,kBAAA;EACA,+BAAA;AA/CN;;AAoDA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;EACA,YAAA;AAjDF;;AAsDE;EACE,6BAAA;EACA,uBAAA;AAnDJ;AAqDI;EACE,6BAAA;EACA,uBAAA;AAnDN;AAsDI;EACE,oBAAA;AApDN;AAsDM;EACE,sBAAA;EACA,uBAAA;AApDR;AAuDM;EACE,4BAAA;EACA,wBAAA;AArDR;AAyDI;EACE,4BAAA;EACA,6BAAA;AAvDN;AA0DI;EACE,sBAAA;EACA,2BAAA;EACA,6BAAA;AAxDN;AA2DI;EACE,sBAAA;EACA,uBAAA;AAzDN;;AA8DA;EAEI;IACE,uBAAA;EA5DJ;EA8DI;IACE,uBAAA;EA5DN;EAgEE;IACE,qCAAA;EA9DJ;EAiEE;IACE,0BAAA;IACA,2BAAA;EA/DJ;EAkEE;IACE,yBAAA;IACA,gBAAA;IACA,eAAA;EAhEJ;EAkEI;IACI,eAAA;EAhER;AACF","sourcesContent":["ion-content {\n    background-color: transparent !important;\n    --background: transparent !important;\n}\n\nion-toolbar {\n  height: 80px !important;\n  --background: transparent !important;\n  \n  &.dark-toolbar {\n    height: 65px !important;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  }\n}\n\nspan {\n    color: white !important;\n}\n\nion-toolbar ion-button {\n  color: white !important;\n\n  &.dark-toolbar {\n    color: black !important;\n  }\n}\n\nion-title {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  position: relative;\n\n  .app-image {\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    object-fit: cover;\n    // border: 1px solid #ddd;\n    cursor: pointer;\n    background: white;\n\n    &.dark-toolbar {\n      // border: 3px solid black;\n      // background: rgb(0, 0, 0, 0.1);\n    }\n  }\n\n  .app-name {\n    font-weight: bold;\n    margin-left: 6px;\n    font-size: x-large;\n    position: absolute;\n    margin-top: 7px;\n\n    &.dark-toolbar {\n      color: black !important;\n    }\n  }\n}\n\n.profile-avatar {\n  width: 36px;\n  height: 36px;\n  cursor: pointer;\n  margin-bottom: 5px;\n  margin-right: 10px;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 50%;\n    border: 1.5px solid black;\n  }\n}\n\n::ng-deep ion-popover.custom-setup-pin-modal {\n  width: 410px !important;\n  height: auto !important;\n  max-height: calc(100vh - 32px) !important;\n  --backdrop-opacity: 0.5;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  \n  // Center the popover\n  &::part(content) {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    border-radius: 20px;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);\n    width: 410px;\n    height: auto;\n    max-height: calc(100vh - 32px);\n  }\n  \n  &::part(backdrop) {\n    background: rgba(0, 0, 0, 0.4) !important;\n    opacity: 1 !important;\n    width: 400vh;\n    height: 150vh;\n    transform: translate(-50%, -50%);\n  }\n}\n\n::ng-deep .ios ion-popover.custom-setup-pin-modal{\n  width: 410px !important;\n  max-height: 280px !important;\n  --backdrop-opacity: 0.5;\n  position: fixed;\n  top: 50%;\n  left: 47.5%;\n  transform: translate(0);\n\n  &::part(content) {\n    border-radius: 20px;\n    position: absolute;\n  }\n\n  &::part(backdrop) {\n    background: rgba(0, 0, 0, 0.3) !important;\n    opacity: 1 !important;\n    width: 400vh;\n    height: 150vh;\n    transform: translate(-50%, -50%);\n  }\n}\n\n::ng-deep ion-popover.custom-setup-pin-modal app-pin {\n  display: block;\n  width: 100%;\n  height: auto;\n  min-height: 240px;\n  border-radius: 20px;\n  overflow: hidden;\n}\n\n@media (max-width: 768px) {\n  ::ng-deep ion-popover.custom-setup-pin-modal {\n    --width: 95%;\n    --max-width: 400px;\n    margin-inline-start: 10px;\n\n    &::part(backdrop) {\n      width: 200vh;\n      height: 200vh;\n      transform: translate(-50%, -50%);\n    }\n  }\n  \n  ::ng-deep ion-popover.custom-setup-pin-modal::part(content) {\n    width: 95%;\n    max-width: 400px;\n  }\n}\n\n.sign-log-btn {\n    border: 1px solid #ddd;\n    border-radius: 5px;\n}\n\nion-toolbar:not(.dark-toolbar) ion-button.active {\n    position: relative;\n    color: white !important;\n    text-shadow: 0 0 8px rgba(255, 255, 255, 0.7);\n    opacity: 1;\n    \n    &::after {\n        content: '';\n        position: absolute;\n        bottom: 0px;\n        left: 50%;\n        transform: translateX(-50%);\n        width: 90%;\n        height: 2px;\n        background: white;\n        border-radius: 2px;\n    }\n  }\n\nion-toolbar.dark-toolbar ion-button.active {\n    position: relative;\n    color: var(--ion-color-primary) !important;\n    text-shadow: 0 0 8px rgba(var(--ion-color-primary-rgb), 0.3);\n    filter: drop-shadow(0 0 4px rgba(255, 255, 255, 0.7));\n    opacity: 1;\n\n     &::after {\n        content: '';\n        position: absolute;\n        bottom: 0px;\n        left: 50%;\n        transform: translateX(-50%);\n        width: 90%;\n        height: 2px;\n        background: var(--ion-color-primary);\n        border-radius: 2px;\n        box-shadow: 0 0 8px rgba(var(--ion-color-primary-rgb), 0.5);\n    }\n  }\n\n/* Responsive Styles */\n@media (max-width: 768px) {\n  .desktop-only {\n    display: none !important;\n  }\n  \n  .mobile-only {\n    display: block !important;\n    margin-left: 10px;\n    font-size: 45px;\n\n    img {\n        font-size: 40px;\n    }\n  }\n\n   ion-menu-button {\n    display: block !important;\n  }\n\n  ion-title {\n    text-align: right !important;\n\n    img {\n      width: 35px !important;\n      height: 35px !important;\n      margin-right: 0px;\n      margin-top: 5px;\n    }\n  }\n\n  ion-content {\n    height: 80px;\n\n    &.dark-toolbar {\n      background-color: transparent !important;\n      color: white;\n    }\n  }\n\n  .ios ion-content.dark-toolbar {\n    height: 80px !important;\n  }\n\n  ion-content.dark-toolbar:not(.ios) {\n    height: 65px !important;\n  }\n\n  ion-toolbar {\n    min-height: 0px !important;\n    padding-top: 25px !important;\n  }\n  \n  .wallet-btn{\n    display: none !important;\n  }\n}\n\n@media (min-width: 769px) {\n  .mobile-only {\n    display: none !important;\n  }\n  .desktop-only {\n    display: inline !important;\n\n    ion-icon {\n      font-size: x-large;\n    }\n  }\n  ion-menu-button {\n    display: none !important;\n  }\n\n  ion-toolbar{\n    --min-height: 65px !important;\n\n    &.dark-toolbar {\n      --min-height: 65px !important;\n    }\n  }\n\n  .ios ion-toolbar.dark-toolbar {\n    --min-height: 80px !important;\n  }\n\n  ion-title {\n    text-align: left !important;\n\n    img {\n      margin-right: 10px;\n\n      &.dark-toolbar {\n        margin-right: 0px !important;\n      }\n    }\n  }\n  \n  ion-content {\n    height: 100px;\n  }\n\n  .ios ion-content.dark-toolbar {\n    height: 80px !important;\n  }\n\n  ion-content.dark-toolbar:not(.ios) {\n    height: 65px !important;\n  }\n  \n  .wallet-btn {\n    display: inline !important;\n    color: white !important;\n    margin-right: 10px !important;\n    margin-bottom: 4px !important;\n    cursor: pointer;\n\n    &.dark-toolbar {\n      color: black !important;    \n    }\n    &.active-wallet {\n      color: var(--ion-color-primary) !important;\n      filter: drop-shadow(0 0 4px rgba(255, 255, 255, 0.7));\n    }\n  }\n}\n\nion-popover {\n  --width: 200px;\n\n  ion-list {\n    padding: 0;\n  }\n\n  ion-item {\n    --padding-start: 10px;\n    --padding-end: 10px;\n    --min-height: 48px;\n\n    ion-icon {\n      margin-right: 12px;\n      color: var(--ion-color-primary);\n    }\n  }\n}\n\n.title-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  height: 100%;\n}\n\n//---IOS---//\n.ios {\n  ion-toolbar {\n    --min-height: 30px !important;\n    height: 82px !important;\n    \n    &.dark-toolbar {\n      --min-height: 30px !important;\n      height: 80px !important;\n    }\n\n    ion-title {\n      padding-inline: 10px;\n\n      .app-image {\n        width: 30px !important;\n        height: 30px !important;\n      }\n\n      .app-name {\n        font-size: medium !important;\n        margin-top: 0 !important;\n      }\n    }\n\n    ion-button {\n      font-size: 0.8rem !important;\n      margin-inline: 2px !important;\n    }\n\n    .wallet-btn {\n      width: 20px !important;\n      margin-left: 5px !important;\n      margin-right: 10px !important;\n    }\n\n    .profile-avatar {\n      width: 24px !important;\n      height: 24px !important;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .ios {\n    ion-content {\n      height: 30px !important;\n      \n      &.dark-toolbar {\n        height: 80px !important;\n      }\n    }\n\n    ion-toolbar {\n      padding: 38px 5px 10px 5px !important;\n    }\n\n    .mobile-only ion-menu-button {\n      font-size: 24px !important;\n      margin-left: 5px !important;\n    }\n\n    .mobile-only {\n      display: block !important;\n      margin-left: 0px;\n      font-size: 35px;\n\n      img {\n          font-size: 40px;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
